var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Base class module for working with API.
 * To make a request, you need to create an instance of this class and call
 * the makeRequest method (returns a promise) with the necessary parameters.
 */
import BrowserStorage from './browserStorage';
/**
 * The base class is a wrapper for all API requests.
 *
 * @constructor
 * @param endpoint One of the Endpoint enum.
 * @param host Optional parameter.
 */
var Base = /** @class */ (function () {
    function Base(endpoint, host) {
        if (host === void 0) { host = window.API_LOCATION; }
        this.endpoint = endpoint;
        this.host = host;
        this.token = localStorage.getItem(BrowserStorage.AuthToken);
    }
    /**
     * All queries to the API should go through this method.
     * It contains all the necessary headers and substitutes the desired
     * projectId, provided no specific has been passed.
     *
     * @param method One of Method enum.
     * @param params Optional, used to pass additional parameters (Ex. Id).
     */
    Base.prototype.makeRequest = function (method, params, customUrl, data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, projectId, body, res;
            return __generator(this, function (_a) {
                try {
                    url = customUrl || "//" + this.host + "/" + this.endpoint;
                    if (params)
                        url += "/" + params;
                    if (url.search(/\?project_id=(?=\d)/gm) === -1) {
                        projectId = sessionStorage.getItem(BrowserStorage.ProjectId) ||
                            window.app.currentProjectId;
                        if (projectId == null)
                            throw new Error();
                        url += (url.indexOf('?') === -1 ? '?' : '&') + "project_id=" + projectId;
                    }
                    body = data && JSON.stringify(data);
                    res = fetch(url, {
                        method: method,
                        credentials: 'include',
                        headers: {
                            Accept: 'application/json, text/javascript, */*; q=0.01',
                            'Content-Type': 'application/json',
                            Authorization: "Bearer " + this.token,
                        },
                        body: body,
                    });
                    return [2 /*return*/, res];
                }
                catch (error) {
                    throw new Error(error);
                }
                return [2 /*return*/];
            });
        });
    };
    return Base;
}());
export default Base;
